<template>
  <DateInput
    :class="$style.dateInput"
    v-bind="$props"
    v-on="$listeners"
  />
</template>

<script lang="ts">
import Vue from 'vue';
import DateInput from '@/scripts/Components/Molecules/Forms/Input/Date/abstracted-date-input.ts.vue';

export default Vue.extend({
  components: {
    DateInput,
  },
});
</script>

<style lang="scss" module>
.dateInput :global {
  input {
    color: black;
    text-align: center;
    text-transform: uppercase;
    border: none;

    font-size: 1rem;

    padding: 0.25rem;
    @media screen and (min-width: 360px) {
      padding: 0.4em;
    }
  }

  div:first-child > input {
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem;
  }
  div:last-child > input {
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }

  // Remove hint
  small {
    display: none;
  }
  span.px-4 {
    padding: 0 !important;
    border-left: 1px solid rgba(0,0,0,0.1);
  }
}
</style>
